﻿import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { MatChipInputEvent } from '@angular/material';
import { Injectable } from '@angular/core';
import { TYPEMESSAGE } from '../common/constant.service';
import { AsEnumerable, asEnumerable } from 'linq-es5';

import * as moment from 'moment';

@Injectable()
export class UtilityService {
    constructor() { }

    format: "DD/MM/YYYY";

    public isEmpty(str: any): boolean {
        return (!str || 0 === str.length || !str.trim());
    }

    setTag(data: any): void {
        data.tag = "";
        if (!this.isEmpty(data.tagA))
            data.tag = data.tagA;
        if (!this.isEmpty(data.tagB))
            data.tag += ', ' + data.tagB;
        if (!this.isEmpty(data.tagC))
            data.tag += ', ' + data.tagC;
        if (!this.isEmpty(data.tagD))
            data.tag += ', ' + data.tagD;

        data.tag = data.tag.trim();
    }

    setTags(data: any): void {
        data.tags = [{ tag: data.tagA }, { tag: data.tagB }, { tag: data.tagC }, { tag: data.tagD }];
        this.removeTagNull(data.tags, { tag: "" });
        this.removeTagNull(data.tags, { tag: null });
    }

    separateTag(data: any): void {
        this.clearSeparateTag(data);
        for (var i = data.tags.length - 1; i >= 0; i--) {
            switch (i) {
                case 0: {
                    data.tagA = data.tags[i].tag;
                    break;
                }
                case 1: {
                    data.tagB = data.tags[i].tag;
                    break;
                }
                case 2: {
                    data.tagC = data.tags[i].tag;
                    break;
                }
                case 3: {
                    data.tagD = data.tags[i].tag;
                    break;
                }
            }
        }
    }

    clearSeparateTag(data: any): void {
        data.tagA = "";
        data.tagB = "";
        data.tagC = "";
        data.tagD = "";
    }

    removeTagNull(data: any, condicion): void {
        for (var i = data.length - 1; i >= 0; i--) {
            if (data[i].tag == condicion.tag)
                data.splice(i, 1);
        }
    }

    addTag(event: MatChipInputEvent, data: any): void {
        let input = event.input;
        let value = event.value;
        if ((value || '').trim())
            data.tags.push({ tag: value });
        if (input)
            input.value = '';
    }

    removeTag(tag: any, data: any): void {
        let index = data.tags.indexOf(tag);

        if (index >= 0)
            data.tags.splice(index, 1);
    }

    setAuditoria(data: any) {
        data.fecCreacion = moment(data.fecCreacion).format('YYYY-MM-DD HH:mm');
        data.fecActualizacion = moment(data.fecActualizacion).format('YYYY-MM-DD HH:mm');
        data.auditoria = data.codUsuarioCreacion + ', ' + data.fecCreacion + ', ' + data.codUsuarioActualizacion + ', ' + data.fecActualizacion;
    }

    getCurrentDay2(){
        var arr = [];
        arr.push( {
            //day: moment().toDate(),.format("YYYY-DD-MM"),
            day: moment().format("DD"),
            today: moment().toDate(),
            firstday : moment().startOf('month').format("YYYY-DD-MM"),
            lastDay : moment().endOf("month").format("YYYY-DD-MM")
        });

        //var test4 = moment().add(1, 'months').date(1).subtract(1, 'days');
        return arr;
    }

    getMinDataToCalendar(data: any){
        return moment(data).add(1, 'days');
    }

    getCurrentDay(){
        return moment().format("DD");
    }

    getCurrentDate(){
        return moment().format("YYYY-MM-DD");
    }

    getFirstDateOfMonth(){
        return moment().startOf('month').format("YYYY-MM-DD");
    }

    getFirstDateToNextMonth(){
        return moment().add(1, 'months').startOf('month').format("YYYY-MM-DD");
    }

    getLastDateToPreviousMonth(){
        return moment().subtract(1,'months').endOf('month').format('YYYY-MM-DD');
    }

    getLastDateOfMonth(){
        return moment().endOf('month').format(this.format);
    }

    getYear(date): number {
        return moment(date, "YYYY-MM-DD").year();
    }

    getMonth(date): number {
        return moment(date, "YYYY-MM-DD").month() + 1;
    }

    getDate(date): number {
        return moment(date, "YYYY-MM-DD").date();
    }

    // getBirthYear(data: any): number{
    //     var b = moment().diff(moment(data, 'YYYYMMDD'), 'years')
    //     return b;
    // }

    // getMinDateFromYears(): any{
    //     var d = moment().subtract(18, 'years');
    //     return d;
    // }

    formatDateTime(date) {
        if (date)
            return moment(date).format("YYYY-MM-DD HH:mm");
        else
            return null;
    }

    formatDate(data: string): string {
        return moment(data, "YYYY-MM-DD").format("YYYY-MM-DD");
    }

    formatDateInput(data: string): string {
        return moment(data, "YYYY-MM-DD").format("DD/MM/YYYY");
    }

    formatDateGrid(data: string): string {
        return moment(data, "YYYY-MM-DD").format("DD/MM/YYYY");
    }

    formatDateTimeGrid(data: string): string {
        return moment(data, "YYYY-MM-DD HH:mm").format("DD/MM/YYYY HH:mm");
    }

    isSameOrAfter(data: any, months: number){
        var dataFinal = moment(data).subtract(months,'months');
        return moment().isSameOrAfter(dataFinal);
    }

    setValor(data: any): void {
        data.valor = "";
        if (!this.isEmpty(data.valorA))
            data.valor = data.valorA;
        if (!this.isEmpty(data.valorB))
            data.valor += ', ' + data.valorB;
        if (!this.isEmpty(data.valorC))
            data.valor += ', ' + data.valorC;
        if (!this.isEmpty(data.valorD))
            data.valor += ', ' + data.valorD;

        data.valor = data.valor.trim();
    }

    addValor(event: MatChipInputEvent, data: any): void {
        let input = event.input;
        let value = event.value;

        if ((value || '').trim())
            data.valores.push({ valor: value.trim() });

        if (input)
            input.value = '';
    }

    removeValor(valor: any, data: any): void {
        let index = data.valores.indexOf(valor);

        if (index >= 0)
            data.valores.splice(index, 1);
    }

    removeValorNull(data: any, condicion): any {
        for (var i = data.length - 1; i >= 0; i--) {
            if (data[i].valor == condicion.valor)
                data.splice(i, 1);
        }
        return data;
    }

    setValores(data: any): void {
        data.valores = [{ valor: data.valorA }, { valor: data.valorB }, { valor: data.valorC }, { valor: data.valorD }];
        this.removeValorNull(data.valores, { valor: "" });
        this.removeValorNull(data.valores, { tag: null });
    }

    separateValor(data: any): void {
        this.clearSeparateValor(data);
        for (var i = data.valores.length - 1; i >= 0; i--) {
            switch (i) {
                case 0: {
                    data.valorA = data.valores[i].valor;
                    break;
                }
                case 1: {
                    data.valorB = data.valores[i].valor;
                    break;
                }
                case 2: {
                    data.valorC = data.valores[i].valor;
                    break;
                }
                case 3: {
                    data.valorD = data.valores[i].valor;
                    break;
                }
            }
        }
    }

    clearSeparateValor(data: any): void {
        data.valorA = "";
        data.valorB = "";
        data.valorC = "";
        data.valorD = "";
    }

    toBoolean(booleanStr: string): boolean {
        return booleanStr.toLowerCase() === "true";
    }

    listarMeses(){
        var meses = [
            { codigo: 1,  nombre:'Enero' },
            { codigo: 2,  nombre:'Febrero' },
            { codigo: 3,  nombre:'Marzo' },
            { codigo: 4,  nombre:'Abril' },
            { codigo: 5,  nombre:'Mayo' },
            { codigo: 6,  nombre:'Junio' },
            { codigo: 7,  nombre:'Julio' },
            { codigo: 8,  nombre:'Agosto' },
            { codigo: 9,  nombre:'Septiembre' },
            { codigo: 10, nombre:'Octubre' },
            { codigo: 11, nombre:'Noviembre' },
            { codigo: 12, nombre:'Diciembre' },
        ];

        return meses;
    }

    getPeriodoFormat(data: any){
        var codmes = Number(data.split('-',1));
        var año = Number(data.split('-')[1]);
        var mes = AsEnumerable(this.listarMeses()).Where(r => r.codigo == codmes).Select(x => x.nombre).FirstOrDefault();
        return mes + ' ' + año;
    }

    getPeriodoFormat2(data: any){
        var anio = data.substring(0,4);
        var codmes = data.substring(4,6);
        var mes = AsEnumerable(this.listarMeses()).Where(r => r.codigo == Number(codmes)).Select(x => x.nombre).FirstOrDefault();
        return mes + ' ' + anio;
    }

    getPeriodoFormat2Array(data: any){
        var anio = data.substring(0,4);
        var codmes = data.substring(4,6);
        var mes = AsEnumerable(this.listarMeses()).Where(r => r.codigo == Number(codmes)).Select(x => x.nombre).FirstOrDefault();
        return new Array(anio, mes);
    }

    getMonthName(data:number){
        return AsEnumerable(this.listarMeses()).Where(r => r.codigo == data).Select(x => x.nombre).FirstOrDefault();
    }
    getMomentString(): string {
        return moment().format('YYYYMMDDHHmmssx');
      }
}
